module.exports = __webpack_public_path__ + "static/media/KW13.f3325bc8.JPG";